import React, { Component } from 'react';
import QueryString from 'query-string';
import ReviewForm from './ReviewForm';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as reviewFormActions from '~/store/modules/reviewForm';
import history from '~/history';

export class ReviewFormContainer extends Component {
  componentDidMount() {
    const { isLoggedIn, ReviewFormActions } = this.props;

    const query = QueryString.stringify({
      redirect: `/reviews/new`,
    });

    if (!isLoggedIn) {
      history.push(`/login?${query}`);
      return;
    }

    ReviewFormActions.getReviewable();
  }

  componentDidUpdate(prevProps) {
    const { location, ReviewFormActions } = this.props;
    if (
      location !== prevProps.location &&
      location.pathname === '/reviews/new'
    ) {
      ReviewFormActions.getReviewable();
    }
  }

  render() {
    return <ReviewForm {...this.props} />;
  }
}

export default connect(
  ({ reviewForm, pender, session }) => ({
    reviewForm,
    isLoggedIn: session.isLoggedIn,
    isLoading: pender.pending['reviewForm/GET_REVIEWABLE'],
    submittingReview: pender.pending['reviewForm/SUBMIT'],
    submitReviewError: pender.failure['reviewForm/SUBMIT'],
  }),
  dispatch => ({
    ReviewFormActions: bindActionCreators(reviewFormActions, dispatch),
  })
)(ReviewFormContainer);



// WEBPACK FOOTER //
// ./src/components/ReviewForm/ReviewFormContainer.js